import requestData from "./requestData";

class contactService {
    sendMail = (data) => requestData("POST", "/api/subscription/subscribe", data)
}

export default new contactService();